export default "__VITE_ASSET__fq10JaZc__"